export const doctorHelpers = {
  calculateBMI: (height: number, weight: number): { bmi: number; category: string } => {
    if (!height || !weight) return { bmi: 0, category: '' };
    
    const heightInMeters = height / 100;
    const bmi = weight / (heightInMeters * heightInMeters);
    const roundedBmi = Math.round(bmi * 100) / 100;
    
    let category = '';
    if (roundedBmi < 18.5) category = 'Underweight';
    else if (roundedBmi >= 18.5 && roundedBmi < 23) category = 'Normal';
    else if (roundedBmi >= 23 && roundedBmi < 25) category = 'Overweight';
    else if (roundedBmi >= 25 && roundedBmi < 30) category = 'Obese I';
    else if (roundedBmi >= 30) category = 'Obese II';
    
    return { bmi: roundedBmi, category };
  },

  validateVitalSigns: (vitals: any): { isValid: boolean; errors: string[] } => {
    const errors: string[] = [];
    
    if (vitals.systolic_bp && (vitals.systolic_bp < 50 || vitals.systolic_bp > 300))
      errors.push('Tekanan darah sistolik harus antara 50-300 mmHg');
    if (vitals.diastolic_bp && (vitals.diastolic_bp < 30 || vitals.diastolic_bp > 200))
      errors.push('Tekanan darah diastolik harus antara 30-200 mmHg');
    if (vitals.temperature && (vitals.temperature < 30 || vitals.temperature > 45))
      errors.push('Suhu tubuh harus antara 30-45°C');
    if (vitals.pulse_rate && (vitals.pulse_rate < 30 || vitals.pulse_rate > 200))
      errors.push('Nadi harus antara 30-200 kali/menit');
    if (vitals.respiratory_rate && (vitals.respiratory_rate < 5 || vitals.respiratory_rate > 50))
      errors.push('Pernapasan harus antara 5-50 kali/menit');
    
    return { isValid: errors.length === 0, errors };
  },
};
